export default function () {
    const registry = {};
    let callbacks = [];
    return {
        callback: (dependencies, handler) => {
            if (executeIfValid(dependencies, handler, registry))
                return;
            callbacks.push({ dependencies, handler });
        },
        set: (key, value) => {
            registry[key] = value;
            callbacks = callbacks.filter(({ dependencies, handler }) => {
                return !executeIfValid(dependencies, handler, registry); // Remove the callback if it was executed; otherwise, keep it for future execution
            });
        }
    };
}
function executeIfValid(deps, handler, registry) {
    if (deps.every((key) => key in registry)) {
        const streams = deps.reduce((prev, curr) => {
            prev[curr] = registry[curr];
            return prev;
        }, {});
        handler(streams);
        return true;
    }
    return false;
}
